<template>
	<div class="warehouse-sale">
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item>
						<el-input v-model="formfilter.style_number" placeholder="款号" clearable
							@keyup.enter.native="onfilter"></el-input>
					</el-form-item>
					<el-form-item>
						<el-date-picker v-model="formfilter.daterange" type="daterange" start-placeholder="开始日期"
							end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow = !filtershow">
				<span>{{ filtershow ? '收起' : '展开' }}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="id" label="明细ID" align="center" header-align="center" width="80px"></el-table-column>
					<el-table-column prop="style_number" label="款号" align="center" header-align="center" min-width="110px"></el-table-column>
					<el-table-column prop="size" label="尺码" align="center" header-align="center" width="70px"></el-table-column>
					<el-table-column prop="quantity" label="件数" align="center" header-align="center" width="70px"></el-table-column>
					<el-table-column label="售价" align="center" header-align="center" width="90px">
						<template slot-scope="scope">¥{{ fenToYuan(scope.row.sale_price) }}</template>
					</el-table-column>
					<el-table-column label="综合拿货价" align="center" header-align="center" width="140px">
						<template slot-scope="scope">
							<span v-if="isOwned(scope.row)">买价 ¥{{ fenToYuan(costRefOf(scope.row)) }}（自有货）</span>
							<span v-else>¥{{ fenToYuan(costRefOf(scope.row)) }}</span>
						</template>
					</el-table-column>
					<el-table-column label="实收小计" align="center" header-align="center" width="100px">
						<template slot-scope="scope">¥{{ fenToYuan(lineSale(scope.row)) }}</template>
					</el-table-column>
					<el-table-column label="保证金扣减" align="center" header-align="center" width="100px">
						<template slot-scope="scope">{{ lineCost(scope.row) > 0 ? '¥' + fenToYuan(lineCost(scope.row)) : '—' }}</template>
					</el-table-column>
					<el-table-column label="利润" align="center" header-align="center" width="100px">
						<template slot-scope="scope">
							<span :class="lineProfitFen(scope.row) < 0 ? 'profit-neg' : 'profit-pos'">¥{{ fenToYuan(lineProfitFen(scope.row)) }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="seller_username" label="供应商" align="center" header-align="center" min-width="90px"></el-table-column>
					<el-table-column prop="sale_time_str" label="销售时间" align="center" header-align="center" width="160px"></el-table-column>
				</el-table>
			</div>
			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
					:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
					@current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import { fenToYuan, apiMsg } from './money.js'

	export default {
		name: 'WarehouseSale',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				filtershow: true,
				formfilter: {
					style_number: '',
					daterange: []
				}
			}
		},
		mounted() {
			this.onlist()
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect
					this.$refs.tablediv.style.height = 'calc(100% - ' + (Number(cr.height) + 30) + 'px)'
				}
			})
			if (this.$refs.filter) {
				this.resizeObserver.observe(this.$refs.filter)
			}
		},
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect()
			}
		},
		methods: {
			fenToYuan: fenToYuan,
			lineSale(row) {
				return Number(row.sale_price || 0) * Number(row.quantity || 0)
			},
			lineComposite(row) {
				if (row.composite_cost != null && row.composite_cost !== '') {
					return Number(row.composite_cost)
				}
				var qty = Number(row.quantity || 0) || 1
				return Number(row.cost_price || 0) + Math.round(Number(row.platform_fee || 0) / qty)
			},
			isOwned(row) {
				if (!row) {
					return false
				}
				if (Number(row.is_owned) === 1) {
					return true
				}
				if (row.is_owned === 0 || row.is_owned === '0') {
					return false
				}
				if (Number(row.buyout_state || 0) === 1) {
					return true
				}
				return row.seller_uid != null && row.seller_uid !== '' && Number(row.seller_uid) === 0
			},
			costRefOf(row) {
				return this.isOwned(row) ? Number(row.buyout_price || 0) : this.lineComposite(row)
			},
			lineCost(row) {
				if (this.isOwned(row)) {
					return 0
				}
				return this.lineComposite(row) * Number(row.quantity || 0)
			},
			lineProfitFen(row) {
				return (Number(row.sale_price || 0) - this.costRefOf(row)) * Number(row.quantity || 0)
			},
			handleCurrentChange() {
				this.onlist()
			},
			handleSizeChange(val) {
				this.page = 1
				this.pageSize = val
				this.onlist()
			},
			onfilter() {
				this.page = 1
				this.onlist()
			},
			onreset() {
				this.formfilter = {
					style_number: '',
					daterange: []
				}
				this.page = 1
				this.onlist()
			},
			onlist() {
				var params = {
					page: this.page,
					limit: this.pageSize,
					role: 'buyer'
				}
				if (this.formfilter.style_number) {
					params.style_number = this.formfilter.style_number
				}
				var range = this.formfilter.daterange
				if (range && range.length === 2) {
					params.btime = Math.floor(new Date(range[0] + ' 00:00:00').getTime() / 1000)
					params.etime = Math.floor(new Date(range[1] + ' 23:59:59').getTime() / 1000)
				}
				this.$axios.get('api/cloud_warehouse/sale_list', { params: params }).then(res => {
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.list = data.list || []
						this.total = data.count || 0
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.warehouse-sale {
		height: 100%;
	}

	.profit-pos {
		color: #67C23A;
	}

	.profit-neg {
		color: #F56C6C;
	}

	.tablebox {
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/components/buyer/warehouse/sale.vue